import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, Stack, Text, Title } from '@mantine/core'

export default function NotFound () {
  return (
    <Box py="xl" sx={{ textAlign: 'center' }}>
      <Stack align="center" spacing="md">
        <Title order={2}>Page not found</Title>
        <Text color="dimmed">
          We&apos;ve looked everywhere and could not find this page.
        </Text>
        <Button component={Link} to="/blog">
          Return to Blog
        </Button>
      </Stack>
    </Box>
  )
}
